/* ==========================================================================
   NMN — Mimane Paris PDP sections — shared JS
   Defensive: every lookup is null-checked because sections can be
   reordered, duplicated, or removed independently in the theme editor.
   ========================================================================== */
(function(){

  /* Accordions (buybox + FAQ) */
  document.querySelectorAll('.nmn-qa .nmn-q').forEach(function(q){
    q.addEventListener('click',function(){
      q.parentElement.classList.toggle('nmn-open');
    });
  });

  /* Bundle selector — one option per product variant.
     A single click must keep FOUR things in sync so nothing conflicts:
       1) the price box (now/was/save)
       2) the main Add to cart button + its hidden variant id
       3) the sticky bar's displayed title/price/compare
       4) the sticky bar's OWN hidden variant id (so it actually submits
          the variant that's currently shown, not the original default) */
  var bundleOpts=document.querySelectorAll('.nmn-bopt[data-variant-id]');
  var atcBtnEl=document.getElementById('nmn-atc-btn');
  var stickyBarEl=document.getElementById('nmn-sticky-atc');
  var nmnAtcBaseLabel = atcBtnEl ? atcBtnEl.textContent.split('—')[0].trim() : 'Add to cart';
  var nmnStickyBaseLabel = stickyBarEl ? (stickyBarEl.getAttribute('data-base-label') || nmnAtcBaseLabel) : nmnAtcBaseLabel;

  if(bundleOpts.length){
    bundleOpts.forEach(function(o){
      o.addEventListener('click',function(){
        if(o.classList.contains('nmn-soldout')) return;

        bundleOpts.forEach(function(x){ x.classList.remove('nmn-sel'); });
        o.classList.add('nmn-sel');

        var priceNow=document.getElementById('nmn-price-now');
        var priceWas=document.getElementById('nmn-price-was');
        var priceSave=document.getElementById('nmn-price-save');
        var variantInput=document.getElementById('nmn-selected-variant-id');
        var stickyBtn=document.getElementById('nmn-sticky-btn');
        var stickyVariantInput=document.getElementById('nmn-sticky-variant-id');
        var stickyTitle=document.getElementById('nmn-sticky-variant-title');
        var stickyPrice=document.getElementById('nmn-sticky-price');
        var stickyCompare=document.getElementById('nmn-sticky-compare');

        /* 1) price box */
        if(priceNow) priceNow.textContent=o.dataset.priceHtml;
        if(priceWas){
          if(o.dataset.wasHtml){ priceWas.textContent=o.dataset.wasHtml; priceWas.style.display=''; }
          else { priceWas.style.display='none'; }
        }
        if(priceSave){
          if(o.dataset.saveHtml){ priceSave.textContent=o.dataset.saveHtml; priceSave.style.display=''; }
          else { priceSave.style.display='none'; }
        }

        /* 2) main button + its variant id */
        if(variantInput) variantInput.value=o.dataset.variantId;
        if(atcBtnEl) atcBtnEl.textContent=nmnAtcBaseLabel+' — '+o.dataset.priceHtml;

        /* 3) sticky bar display */
        if(stickyTitle) stickyTitle.textContent=o.dataset.label;
        if(stickyPrice) stickyPrice.textContent=o.dataset.priceHtml;
        if(stickyCompare){
          if(o.dataset.wasHtml){ stickyCompare.textContent=o.dataset.wasHtml; stickyCompare.style.display=''; }
          else { stickyCompare.style.display='none'; }
        }
        if(stickyBtn) stickyBtn.textContent=nmnStickyBaseLabel+' — '+o.dataset.priceHtml;

        /* 4) sticky bar's own hidden variant id — critical: without this the
           sticky "Add to cart" would still submit the ORIGINAL variant even
           though the price shown now matches the newly selected one */
        if(stickyVariantInput) stickyVariantInput.value=o.dataset.variantId;
      });
    });
  }

  /* Sticky add-to-cart bar visibility */
  var nmnBuy=document.getElementById('nmn-buy');
  var nmnSticky=document.getElementById('nmn-sticky-atc');
  if(nmnBuy && nmnSticky){
    window.addEventListener('scroll',function(){
      var past = nmnBuy.getBoundingClientRect().bottom < 0;
      var nearFooter = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 400);
      nmnSticky.classList.toggle('nmn-show', past && !nearFooter);
    });
  }

  /* Countdown timer — resets nightly at 23:59:59 local time.
     Wire `data-end` on #nmn-cd to a real ISO deadline if you need a fixed promo end time. */
  function nmnTick(){
    var cdWrap=document.querySelector('.nmn-cd');
    var h=document.getElementById('nmn-cd-h');
    var m=document.getElementById('nmn-cd-m');
    var s=document.getElementById('nmn-cd-s');
    if(!h||!m||!s) return;

    var end;
    var fixedEnd = cdWrap ? cdWrap.getAttribute('data-end') : null;
    if(fixedEnd){
      end = new Date(fixedEnd);
    } else {
      end = new Date();
      end.setHours(23,59,59,999);
    }
    var d=Math.max(0, end-new Date());
    var hh=Math.floor(d/3.6e6), mm=Math.floor(d%3.6e6/6e4), ss=Math.floor(d%6e4/1e3);
    h.textContent=String(hh).padStart(2,'0');
    m.textContent=String(mm).padStart(2,'0');
    s.textContent=String(ss).padStart(2,'0');
  }
  nmnTick();
  setInterval(nmnTick,1000);

  /* UGC video — click video or overlay button to play/pause; overlay hides while playing */
  document.querySelectorAll('.nmn-ugc-media').forEach(function(wrap){
    var video=wrap.querySelector('.nmn-ugc-video-el');
    var playBtn=wrap.querySelector('.nmn-ugc-play');
    if(!video) return;

    function setPlayingState(isPlaying){
      wrap.classList.toggle('nmn-playing', isPlaying);
    }

    function toggle(e){
      if(e) e.stopPropagation();
      if(video.paused || video.ended){ video.play(); } else { video.pause(); }
    }

    if(playBtn){ playBtn.addEventListener('click', toggle); }
    video.addEventListener('click', toggle);
    video.addEventListener('play', function(){ setPlayingState(true); });
    video.addEventListener('pause', function(){ setPlayingState(false); });
    video.addEventListener('ended', function(){ setPlayingState(false); });

    if(!video.paused && !video.ended){ setPlayingState(true); }
  });

  /* Gallery — thumbnail click switches the active main slide, pausing any playing video */
  var nmnGalMain=document.getElementById('nmn-gal-main');
  var nmnGalThumbs=document.getElementById('nmn-gal-thumbs');
  if(nmnGalMain && nmnGalThumbs){
    var nmnSlides=nmnGalMain.querySelectorAll('.nmn-gal-slide');
    var nmnThumbs=nmnGalThumbs.querySelectorAll('.nmn-gal-thumb');

    function nmnPauseSlide(slide){
      var media=slide.querySelector('video, iframe');
      if(media && media.tagName === 'VIDEO' && !media.paused){ media.pause(); }
      if(media && media.tagName === 'IFRAME'){
        // external video (YouTube/Vimeo) — reload src to stop playback
        media.src = media.src; // eslint-disable-line no-self-assign
      }
    }

    function nmnGoToSlide(index){
      nmnSlides.forEach(function(slide){
        var isTarget = slide.dataset.index === String(index);
        if(!isTarget) nmnPauseSlide(slide);
        slide.classList.toggle('nmn-active', isTarget);
      });
      nmnThumbs.forEach(function(thumb){
        thumb.classList.toggle('nmn-active', thumb.dataset.index === String(index));
      });
    }

    nmnThumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        nmnGoToSlide(thumb.dataset.index);
      });
    });
  }

})();